export default "__VITE_ASSET__bNB$0dNN__"